import React from "react";
import { motion } from "framer-motion";
import { ASSETS } from "../lib/api";
import { useT } from "../i18n/LanguageContext";

export const Footer = () => {
  const { t } = useT();
  const x = t.footer;
  return (
    <footer className="relative pt-10 md:pt-12 pb-10 px-6 md:px-12 text-center bg-noir" data-testid="footer">
      <div className="absolute inset-0 grain pointer-events-none opacity-50" />
      <div className="max-w-[760px] mx-auto relative">
        <motion.img
          initial={{ opacity: 0, scale: 0.9 }} whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }} transition={{ duration: 1.2 }}
          src={ASSETS.logo} alt="Provalo Spiedinificio"
          className="h-20 md:h-24 mx-auto opacity-95"
        />
        <motion.hr
          initial={{ scaleX: 0 }} whileInView={{ scaleX: 1 }} viewport={{ once: true }}
          transition={{ delay: 0.3, duration: 1.2 }}
          className="hairline mx-auto mt-12 w-32 origin-center"
        />
        <motion.p
          initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}
          transition={{ delay: 0.5, duration: 1 }}
          className="mt-10 font-display italic text-[22px] md:text-[28px] leading-[1.5] text-[var(--pn-milk)]"
        >
          {x.claim_a}<br />
          <span className="text-[var(--pn-amber)]">{x.claim_b}</span>
        </motion.p>
        <p className="mt-14 text-[12px] tracking-[0.3em] uppercase text-[var(--pn-cream)]/35">
          {x.tagline}
        </p>
        <p className="mt-3 text-[11px] text-[var(--pn-cream)]/25 font-light">
          © {new Date().getFullYear()} Provalo Spiedinificio · {x.rights}
        </p>
      </div>
    </footer>
  );
};
